import {
  Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';

const ConfirmDeleteDialog = ({
  open,
  onCancel,
  onConfirm,
  title,
  description,
  confirmLabel = 'Eliminar',
  cancelLabel = 'Cancelar',
  confirmColor = 'error',
  loading = false,
}) => (
  <Dialog
    open={open}
    onClose={loading ? undefined : onCancel}
    aria-labelledby="confirm-delete-dialog-title"
    aria-describedby="confirm-delete-dialog-description"
  >
    <DialogTitle id="confirm-delete-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="confirm-delete-dialog-description">
        {description}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>
        {cancelLabel}
      </Button>
      <Button
        onClick={onConfirm}
        color={confirmColor}
        variant="contained"
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteDialog;
